import React from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { Role } from "../../../types/modules/admin/role.type";
import InputPhoneField from "../../form/InputPhoneField";

export interface EmployeeFormData {
  name: string;
  phone: string;
  roleId: number; // or string depending on your backend
}

interface Props {
  register: UseFormRegister<EmployeeFormData>;
  errors: FieldErrors<EmployeeFormData>;
  roles: Role[]; // list of roles for the select
  defaultValues?: EmployeeFormData;
  setValue: UseFormSetValue<EmployeeFormData>;
  watch: UseFormWatch<EmployeeFormData>;
}

const EmployeeForm: React.FC<Props> = ({
  register,
  errors,
  roles,
  defaultValues,
  setValue,
  watch,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4">
      {/* Name Input */}
      <InputField
        placeholder=""
        label={t("employee_name")}
        defaultValue={defaultValues?.name}
        register={register("name", { required: t("required_field") })}
        error={errors.name}
      />

      {/* Phone Input */}
      <InputPhoneField
        placeholder=""
        label={t("employee_phone")}
        defaultValue={defaultValues?.phone}
        register={register("phone", { required: t("required_field") })}
        error={errors.phone}
        rounded={8}
      />

      {/* Role Select */}
      <div className="flex flex-col gap-2">
        <label className="font-semibold text-Black">{t("employee_role")}</label>
        <select
          className="border rounded p-2"
          {...register("roleId", { required: t("required_field") })}
          defaultValue={defaultValues?.roleId || ""}
        >
          <option value="">{t("select_role")}</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>
        {errors.roleId && (
          <p className="text-danger text-sm">{errors.roleId.message}</p>
        )}
      </div>
    </div>
  );
};

export default EmployeeForm;
